import React from "react";
import { Link } from "react-router-dom";
const SortCard = ({ className, changeObj, getValue }) => {
  const links = [
    {
      label: "ارزان ترین",
      key: "minPrice",
    },
    {
      label: "گران ترین",
      key: "maxPrice",
    },

    {
      key: "newer",
      label: "جدید ترین",
    },
    {
      key: "older",
      label: "قدیمی ترین",
    },
  ];

  return (
    <div className={`sort-card sticky-top ${className}`}>
      <h5>مرتب سازی: </h5>
      <div>
        <ul className="">
          {links.map(link => {
            return (
              <li
                className="pointer"
                onClick={() => changeObj("sort", link.key)}
                data-active={getValue("sort") == link.key}
              >
                <a>{link.label}</a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default SortCard;
